import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';

const DotsContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '$core.spacing.10',
});

const Dot = styled('div', {
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: '$core.color.neutral.60',
  animation: 'pulse 1.4s ease-in-out infinite',
  '&:nth-child(1)': {
    animationDelay: '0s',
  },
  '&:nth-child(2)': {
    animationDelay: '0.2s',
  },
  '&:nth-child(3)': {
    animationDelay: '0.4s',
  },
  '@keyframes pulse': {
    '0%, 80%, 100%': {
      opacity: 0.4,
      transform: 'scale(1)',
    },
    '40%': {
      opacity: 1,
      transform: 'scale(1.2)',
    },
  },
});

export const LoadingDots: React.FC = () => {
  return (
    <DotsContainer>
      <Dot />
      <Dot />
      <Dot />
    </DotsContainer>
  );
};
